import Lookup from 'src/componentes/select2';

const ClassificacaoRiscoLookup = ({ clearable = false, ...rest }) => (
  <Lookup
    labelKey="descricao"
    valueKey="id"
    url="/ClassificacaoRiscoLookup"
    clearable={clearable}
    {...rest}
  />
);

export default ClassificacaoRiscoLookup;
